/**
 * Whether a contact profile pin is already represented in the modal gallery.
 * - Session rows: `_sourceContactPinId` set when adding from profile; temp gallery ids.
 * - Persisted rows: API `id` is usually the *shortlist pin* id, not the contact pin id, so we
 *   also match on `file_id` and `url` like the old behaviour implied by shared media.
 * `_sourceContactPinId` is stripped on save (see `updateShortlistBlock` pin pick list).
 */

function normalizeUrl(url) {
  if (url == null || url === '') return '';
  return String(url).trim();
}

/**
 * @param {object} g - gallery pin
 * @param {object} profilePin - contact profile pin
 */
export function matchesProfilePinInGallery(g, profilePin) {
  if (profilePin?.id == null) return false;

  const pinnedId = profilePin.id;

  if (g._sourceContactPinId != null) {
    if (g._sourceContactPinId === pinnedId) return true;
    if (String(g._sourceContactPinId) === String(pinnedId)) return true;
  }

  const gIdIsTemp = typeof g.id === 'string' && g.id.startsWith('temp-');

  if (!gIdIsTemp) {
    if (g.id === pinnedId) return true;
    if (String(g.id) === String(pinnedId)) return true;
  }

  if (
    profilePin.file_id != null &&
    g.file_id != null &&
    Number(profilePin.file_id) === Number(g.file_id)
  ) {
    return true;
  }

  const pUrl = normalizeUrl(profilePin.url);
  const gUrl = normalizeUrl(g.url);
  if (pUrl !== '' && pUrl === gUrl) {
    return true;
  }

  return false;
}

export function isProfilePinInGallery(profilePin, gallery = []) {
  if (profilePin?.id == null) return false;
  return gallery.some(g => matchesProfilePinInGallery(g, profilePin));
}

export function findGalleryPinForProfilePin(profilePin, gallery = []) {
  if (profilePin?.id == null) return undefined;
  return gallery.find(g => matchesProfilePinInGallery(g, profilePin));
}
